// extracted by mini-css-extract-plugin
module.exports = {"aniFGsapA1":"aniFGsapA1_aniFGsapA1__M2hEo"};